export default __webpack_public_path__ + "static/media/plant-color.66f1af09.svg";